<template>
  <div>
    <el-form label-width="100px">
      <el-form-item label="选择日期范围">
        <el-col :span="12">
          <el-date-picker
            v-model="vdate"
            type="daterange"
            alue-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%;"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            @change="dateChange">
          </el-date-picker>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" @click="exportData" v-loading="exportloading">导出</el-button>
            <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-form-item>
    </el-form>
    <el-tabs v-if="$route.path.indexOf('_editor') === -1" v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="新增保额统计" name="sum_amount_count" v-loading="loading">
        <template>
          <el-table :data="allListData" stripe border style="width: 100%" :height="wheight-230">
            <el-table-column prop="user_id" label="用户ID"></el-table-column>
            <el-table-column prop="created" label="创建时间">
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">创建时间<br/>{{scope.row.created|datetime('yyyy-MM-dd hh:mm:ss')}}</div>
                  <span>{{scope.row.created|datetime}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="plan_code" label="产品代码"></el-table-column>
            <el-table-column prop="order_id" label="订单编号"></el-table-column>
            <el-table-column prop="policyNo" label="凭证号"></el-table-column>
            <el-table-column prop="type" label="消费类型"></el-table-column>
            <el-table-column prop="price" label="消费金额"></el-table-column>
            <el-table-column prop="sum_amount" label="累计保额"></el-table-column>
            <el-table-column prop="new_amount" label="新增保额"></el-table-column>
            <el-table-column prop="premium" label="保费"></el-table-column>
            <el-table-column prop="end_orsementNo" label="退保单号"></el-table-column>
            <el-table-column prop="status" label="状态"></el-table-column>
            <el-table-column prop="startDate" label="起保时间">
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">创建时间<br/>{{scope.row.startDate|datetime('yyyy-MM-dd hh:mm:ss')}}</div>
                  <span>{{scope.row.startDate|datetime}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="endDate" label="终保时间">
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">创建时间<br/>{{scope.row.endDate|datetime('yyyy-MM-dd hh:mm:ss')}}</div>
                  <span>{{scope.row.endDate|datetime}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="createDate" label="投保日期">
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">创建时间<br/>{{scope.row.createDate|datetime('yyyy-MM-dd hh:mm:ss')}}</div>
                  <span>{{scope.row.createDate|datetime}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="refundNo" label="退款订单号"></el-table-column>
          </el-table>
        </template>
      </el-tab-pane>
      <div class="content-padded content-center">
        <el-pagination
                background
                layout="total, sizes, prev, pager, next"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :current-page.sync="params.page"
                :page-sizes="[10,20,50]"
                :total="total_count"
                :page-size="params.pageSize">
        </el-pagination>
      </div>
    </el-tabs>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import json2csv from 'json2csv'
  import { getAmountData } from '../../api/datacube'
  export default {
    data () {
      return {
        vdate: '',
        loading: true,
        exportloading: false,
        total_count:0,
        activeName: 'sum_amount_count',
        params: {
          start:new Date().getFullYear()+"-" + (new Date().getMonth()+1) + "-" + (new Date().getDate()-1),
          end: new Date().getFullYear()+"-" + (new Date().getMonth()+1) + "-" + (new Date().getDate()-1),
          page: 1,
          pageSize: 20,
        },
        allListData: [],
        // fields: ['item_bn', 'category_name', 'item_name', 'sales_count', 'fixed_amount_count', 'settle_amount_count'],
        fields: ['user_id','created','plan_code','order_id', 'policyNo', 'type', 'price', 'sum_amount', 'new_amount','premium','end_orsementNo','status','startDate','endDate','createDate','refundNo'],
        pickerOptions: {
          shortcuts: [{
            text: '最近一天',
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      exportData () {
        this.exportloading = true
        this.params.export = 1
          getAmountData(this.params).then(res => {
              console.log(res);
          this.exportloading = false
          if (res.data.status) {
                    this.$message({
                        type: 'success',
                        message: '已加入执行队列，请在设置-导出列表中下载'
                    })
                    return
                } else if (res.data.url) {
                    this.downloadUrl = res.data.url
                    this.downloadName = res.data.filename
                    this.downloadView = true
                } else {
                  this.$message({
                      type: 'error',
                      message: '无内容可导出 或 执行失败，请检查重试'
                  })
                  return
                }
        }).catch( error => {
          this.exportloading = false
        })
      },
      createDownLoadClick(content, fileName) {
        const link = document.createElement("a");
        link.href = encodeURI(content);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      handleCurrentChange (page_num) {
          console.log(page_num);
          this.loading = false
          this.params.page = page_num
          this.getParams()
          this.getAmountData(this.params)
      },
      handleSizeChange (pageSize) {
          console.log(pageSize);
          this.loading = false
          this.params.page = 1
          this.params.pageSize = pageSize
          this.getParams()
          this.getAmountData(this.params)
      },
      getParams () {
          console.log(this.params.start)
          console.log(this.params.end)

          this.params.start = this.params.start
          this.params.end = this.params.end
      },
      MyBrowserIsIE() {
        let isIE = false;
        if (
          navigator.userAgent.indexOf("compatible") > -1 &&
          navigator.userAgent.indexOf("MSIE") > -1
        ) {
          // ie浏览器
          isIE = true;
        }
        if (navigator.userAgent.indexOf("Trident") > -1) {
          // edge 浏览器
          isIE = true;
        }
        return isIE;
      },
      handleClick (tab, event) {
      },
      dateChange (val) {
        if (!val) {
          return false
        }
        this.params.start = val[0]
        this.params.end = val[1]
        this.params.export = 0
        this.getAmountData()
      },
        getAmountData() {
        this.loading = true
          getAmountData(this.params).then(res => {
          this.allListData = res.data.data.list
          this.total_count = res.data.data.total_count
          this.loading = false
        }).catch( error => {
          this.$message({
            type: 'error',
            message: '获取统计信息出错'
          })
        })
      },
    },
    mounted () {
      var start = new Date();
      var end = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
      this.vdate = [start, end]
      this.getAmountData()
    }
  }
</script>


// WEBPACK FOOTER //
// sumAmountdata.vue?c533b376